
      <app-hsl [hue]="hue" [(ngModel)]="saturationLightness" (ngModelChange)="calculateColor()" class="middle"></app-hsl>
      <app-hue [(ngModel)]="hue" (ngModelChange)="calculateColor()"></app-hue>
    